import React from "react";
import List from "../../components/List";
import api from "../../api";

export default function () {
  return React.useMemo(() => {
    return (
      <List
        columns={List.columns.Page_Follow}
        orderOptions={true}
        onRequest={(params) =>
          api.pages
            .follow(params)
            .catch(() => ({ data: [], total: 0 }))
            .then(({ data, total }) => {
              const pages = data.map((item: { info: any }) => {
                const page = item.info;
                const meta = { ...item };
                delete meta.info;
                page.meta = meta;
                page.author = page.publisher;
                delete page.publisher;
                return page;
              });
              return { pages, total };
            })
        }
      />
    );
  }, []);
}
